import { CircularProgress, Stack, Typography } from '@mui/material';
import { Box } from '@mui/system';
import ReactPlayer from 'react-player';
import { useEffect, useState } from 'react';
import axios from '../../util/Axios';

export function ArmsVideo({ test }) {
  const [video, setVideo] = useState('');

  useEffect(() => {
    if (test?.armsVideoUrl) {
      axios('/strokeTests/' + test.uuid + '/armMovement/video', { responseType: 'blob' }).then((response) => setVideo(window.URL.createObjectURL(response.data)));
    } else {
      setVideo(null);
    }
  }, [test]);

  return (
    <>
      <Stack spacing={3}>
        {video ? (
          video.length === 0 ? ( //the video is being loaded
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <CircularProgress color="inherit" />
              <Typography>Video is downloading</Typography>
            </Box>
          ) : (
            <Box>
              <ReactPlayer style={{ margin: 'auto' }} height="450px" width="795px" controls={true} url={video} />
            </Box>
          )
        ) : null}
      </Stack>
    </>
  );
}
